// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__90i3Z","location":"Header_location__RPCD_"};